















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxAutocomplete } from 'devextreme-vue';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import MailDialog from '@/modules/quotations/components/dialogs/MailPopup.vue';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';

import { DxForm, DxSimpleItem, DxLabel } from 'devextreme-vue/form';

import { QuotationDetailedDto, QuotationsClient, GenerateQuotationDocumentCommand, FinanceDocumentSettings } from '@/data/web-api-client';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxAutocomplete,
    MailDialog,
    PdfViewer,
  },
})
export default class QuotationDocument extends Vue {
  @Prop({ required: true })
  quotation!: QuotationDetailedDto;
  pdfSize: number = 450;
  settings: FinanceDocumentSettings = new FinanceDocumentSettings({
    hideUnitPrices: false,
    hideLineTotals: false,
    hideLineAmounts: false,
    hideSubtotals: false,
    hideTotals: false,
    hideSubtotalDetails: false,
    groupArticlesByCategory: false,
  });

  document: {
    loading: boolean;
    initialised: boolean;
    url: string;
  } = {
    loading: false,
    initialised: false,
    url: '',
  };

  languages: any[] = [];

  mounted() {
    this.pdfSize = window.innerHeight - 275;
    if (this.quotation.documentSettings && this.quotation.documentSettings !== null) {
      Object.assign(this.settings, this.quotation.documentSettings);
    }
    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];
    this.loadDocument();
  }

  async loadDocument() {
    try {
      this.document.loading = true;
      const result = await new QuotationsClient(undefined, this.$axios).getDocument(this.$route.params.id);

      this.document.url = window.URL.createObjectURL(result.data);
      this.document.initialised = true;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  async generateDocument() {
    try {
      this.document.loading = true;
      const result = await new QuotationsClient(undefined, this.$axios).generateDocument(
        new GenerateQuotationDocumentCommand({
          id: this.$route.params.id,
          documentSettings: new FinanceDocumentSettings(this.settings),
        })
      );

      this.document.url = window.URL.createObjectURL(result.data);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  mailSend() {
    this.$emit('mailSend');
  }

  openMailDialog() {
    (this.$refs.MailDialog as MailDialog).open();
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      showClearButton: 'true',
    };
  }
}
